<template>
  <el-form
      ref="form"
      :model="form"
      :label-width="!campaignTargetType ? '119px' : '140px' ">
    <div class="form-content">
      <div class="form-cell" v-if="campaignTargetType">
        <el-form-item
          label="广告活动投放类型"
          prop="campaignTargetType"
          :rules="[ { required: true, message: '请选择广告投放类型', trigger: ['change'] } ]">
          <gj-select
              v-if="campaignTargetTypeOption.length > 1"
              v-model="form.campaignTargetType"
              :options="campaignTargetTypeOption"
              :clearable="false"
              width="200px"
              placeholder="请选择">
          </gj-select>
          <template v-else>
            {{campaignTargetTypeOption[0].text | defaultShow}}
          </template>
        </el-form-item>
      </div>
      <div class="form-cell">
        <el-form-item
          label="广告活动名称"
          prop="campaignId"
          :rules="[
            { required: isMeaningless(campaign), message: '请选择广告活动', trigger: ['change'] }
          ]"
          :style="{'margin-bottom': isMeaningful(group) ? '0' : '15px' }">
          <template #label>
            <span>广告活动名称</span>
            <gj-help style="padding-left: 3px">广告活动名称仅对您可见，因此请选择一个您可以轻松识别并在日后参考的名称。</gj-help>
          </template>
          <gj-select
              v-if="isMeaningless(campaign)"
              v-model="form.campaignId"
              :options="proxyCampaignOption"
              :loading="campaignLoading"
              width="200px"
              :clearable="false"
              placeholder="请选择"
              @input="campaignChange($event)"
              @input-option="campaignOptionChange($event)">
          </gj-select>
          <template v-else>
            {{campaign.campaignName | defaultShow}}
          </template>
        </el-form-item>
      </div>
      <div class="form-cell" v-if="groupSelect">
        <el-form-item label="广告组名称" prop="groupId"
          :rules="[
            { required: isMeaningless(group), message: '请选择广告组', trigger: ['change'] }
          ]"
          :style="{'margin-bottom': isMeaningful(group) ? '8px' : '15px' }">
          <gj-select
              v-if="isMeaningless(group)"
              v-model="form.groupId"
              :options="proxyGroupOption"
              :loading="groupLoading"
              width="200px"
              :clearable="false"
              placeholder="请选择"
              @input-option="groupOptionChange($event)">
          </gj-select>
          <template v-else>
            {{group.groupName | defaultShow}}
          </template>
        </el-form-item>
      </div>
      <div class="form-cell" v-if="groupInput">
        <el-form-item label="广告组名称" prop="groupName"
          :rules="[
            { required: true, validator: validatorName, trigger: ['change'] },
          ]">
          <template #label>
            <span>广告组名称</span>
            <gj-help style="padding-left: 3px">	仅在您管理广告时可见。</gj-help>
          </template>
          <gj-input
              v-model="form.groupName"
              width="200px"
              placeholder="请输入"
              @blur="handleIsExist">
          </gj-input>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
  import { adBasePropsMixin } from "modules/ad/common/mixin";
  import { formMixin, isMeaningfulMixin, isMeaninglessMixin } from "@/minxins";
  import { AdGroupEnum } from "modules/ad/common/enum";
  import { SP } from "@/api/ad";
  import { isMeaningful } from "@/utils/common";
  import { AdTypeEnum } from "modules/ad/common/enum";

  export default {
    name: "app-base-info",
    mixins: [adBasePropsMixin, formMixin, isMeaninglessMixin, isMeaningfulMixin],
    props: {
      marketId: {
        required: true
      },
      campaignTargetTypeOption: {
        default: () => AdGroupEnum.SP.targetingTypeOption
      },
      campaignOption: {
        default: () => []
      },
      groupOption: {
        default: () => []
      },
      campaignTargetType: {
        type: Boolean,
        default: false
      },
      groupSelect: {
        type: Boolean,
        default: false
      },
      groupInput: {
        type: Boolean,
        default: false
      },
      campaign: {
        required: false,
        default: null
      },
      group: {
        required: false,
        default: null
      }
    },
    data() {
      return {
        AdGroupEnum: AdGroupEnum,
        proxyCampaignOption: [],
        proxyGroupOption: [],
        campaignLoading: false,
        groupLoading: false,
        validatorName: this._.debounce((rule, value, callback) => {
          if (!value) return callback(new Error('请输入广告组名称'));
          if (!this.form.campaignId) return callback(new Error('请选择广告活动'));
          const params = {
            marketId: this.marketId,
            campaignId: this.form.campaignId,
            name: value
          }
          SP.existByNameGroup(params).then(({data}) => {
            data ? callback('广告组名称已存在') : callback()
          })
        }, 500),
      }
    },
    created() {
      this.proxyCampaignOption = this.campaignOption;
      this.proxyGroupOption = this.groupOption;
      if (isMeaningful(this.campaign)) {
        this.form.campaignId = this.campaign.campaignId;
        this.form.campaignName = this.campaign.campaignName;
        this.form.expressionType = this.campaign.targetingType;
        this.campaignChange(this.campaign.campaignId);
      }
      if (isMeaningful(this.group)) {
        this.form.groupId = this.group.groupId;
        this.form.groupName = this.group.groupName;
      }
    },
    watch: {
      'form.campaignTargetType': {
        handler: function(campaignTargetType) {
          if (isMeaningful(campaignTargetType)) {
            this.campaignTargetTypeChange(campaignTargetType);
          }
        },
        immediate: true
      }
    },
    methods: {
      handleIsExist(){
        const params={
          marketId:this.marketId,
          campaignId:this.form.campaignId,
          groupName:this.form.groupName,
          adsType: AdTypeEnum.SP
        }
      },
      campaignTargetTypeChange(targetingType) {
        
        if (isMeaningful(this.campaign)) {
          this.proxyGroupOption = [];
          this.form.groupId = null;
          this.form.groupName = null;
          this.campaignChange(this.campaign.campaignId);
          return;
        }
        
        this.proxyCampaignOption = [];
        this.proxyGroupOption = [];
        this.form.campaignId = null;
        this.form.groupId = null;
        this.form.campaignName = null;
        this.form.groupName = null;
        this.campaignLoading = true;
        SP.selectSpCampaigns({
          marketId: this.marketId,
          states: [0, 1],
          groupTargetingTypes: targetingType === AdGroupEnum.SP.targetingType.ALL ? null : [ targetingType ],
        })
          .then(({data}) => {
            this.proxyCampaignOption = data.map(e => ({
              id: e.campaignId,
              text: e.campaignName,
              targetingType: e.targetingType
            }));
          })
          .then(() => this.campaignLoading = false);
      },
      campaignChange(campaignId) {
        if (isMeaningful(this.group) || this.groupInput) {
          // 校验广告组名称
          this.form.groupName && this.$refs.form.validateField(['groupName']);
          return;
        }
        
        this.proxyGroupOption = [];
        this.form.groupId = null;
        this.form.groupName = null;
        this.groupLoading = true;
        SP.selectSpGroups({
          marketId: Number(this.marketId),
          campaignIds: [ Number(campaignId) ],
          groupTargetingTypes: this.form.campaignTargetType === AdGroupEnum.SP.targetingType.ALL ? null : [this.form.campaignTargetType],
          states: [ 0 , 1 ]
        })
          .then(({data}) => {
            this.proxyGroupOption = data.map(e => ({
              id: e.groupId,
              text: e.groupName,
              bid: e.defaultBid
            }))
          })
          .then(() => this.groupLoading = false);
      },
      campaignOptionChange(option) {
        if (option) {
          this.form.campaignName = option.text;
          this.form.expressionType = option.targetingType;
          this.$emit('input-campaign-option', option);
        }
      },
      groupOptionChange(option) {
        if (option) {
          this.form.groupName = option.text;
          this.$emit('input-group-option', option);
        }
      },
      formValidate() {
        return new Promise((resolve, reject) => {
          this.$refs.form.validate(valid => {
            valid ? resolve() : reject()
          });
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
.form-content {
  display: flex;
  flex-wrap: wrap;
  .form-cell {
    padding-right: 100px;
  }
}
</style>

